import React, { useEffect, useState } from "react";
import Orange_Btn from "../../common_btn/orange_btn/Orange_Btn";
import { Form, Modal } from "react-bootstrap";
import { useForm } from "react-hook-form";
import "./Login_Modal.css";
import {
  faCircleCheck,
  faEye,
  faEyeSlash,
  faPen,
} from "@fortawesome/free-solid-svg-icons";
import PasswordChecklist from "react-password-checklist";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Reset_Password_Modal from "../reset_password_modal/Reset_Password_Modal";
import { useDispatch } from "react-redux";
import { userSignUp } from "../../../../features/auth/authSlice";
import { formatCountdown, RegxExpression } from "../../../../utils/common";
import Brown_btn from "../../common_btn/brown_btn/Brown_btn";
import Login_Modal from "./Login_Modal";

import { sendSignupOtp, verifyOtp } from "../../../../features/auth/authSlice";
import Success_Modal from "../success_modal/Success_Modal";
import Delete_Modal from "../delete_modal/Delete_Modal";
const OTP_TIMER = 120;
const SignUp_Modal = ({
  onHide,
  setShowAccountCreted,
  showSignUp,
  setShowSignUp,
  ...props
}) => {
  // const [showSignUp, setShowSignUp] = useState(false);
  const [successText, setSuccessText] = useState("");
  const [showSucess, setShowSucess] = useState(false);
  const [showError, setShowError] = useState(false);

  const [password, setPassword] = useState("");
  const [passwordAgain, setPasswordAgain] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showPasswordOne, setShowPasswordOne] = useState(false);
  const [iconOne, setIconOne] = useState(faEyeSlash);
  const [iconTwo, setIconTwo] = useState(faEyeSlash);

  const [otpSent, setOtpSent] = useState(false);
  const [otpVerified, setOtpVerified] = useState(false);
  const [otp, setOtp] = useState("");
  const [otpLoading, setOtpLoading] = useState(false);
  const [otpCountdown, setOtpCountdown] = useState(0);

  useEffect(() => {
    if (otpCountdown <= 0) return;

    const timer = setTimeout(() => {
      setOtpCountdown((prev) => prev - 1);
    }, 1000);

    return () => clearTimeout(timer);
  }, [otpCountdown]);

  useEffect(() => {
    if (otpCountdown === 0 && otpSent && !otpVerified) {
      setOtpSent(false);
      setOtp("");
    }
  }, [otpCountdown, otpSent, otpVerified]);

  const togglePasswordVisibility = (field) => {
    if (field === "password") {
      setShowPassword(!showPassword);
      setIconOne(showPassword ? faEyeSlash : faEye);
    } else if (field === "reenterPassword") {
      setShowPasswordOne(!showPasswordOne);
      setIconTwo(showPasswordOne ? faEyeSlash : faEye);
    }
  };

  const {
    control,
    register,
    handleSubmit,
    getValues,
    setValue,
    setError,
    clearErrors,
    formState: { errors },
    reset,
    trigger,
  } = useForm();

  const dispatch = useDispatch();
  const onSubmit = async (data) => {
    if (!otpVerified) {
      setError("email", {
        type: "manual",
        message: "Please verify your email with OTP before signing up",
      });
      return;
    }

    const res = await dispatch(userSignUp(data));

    if (res.meta?.requestStatus === "fulfilled") {
      onHide();
      setShowAccountCreted();
      // //   setShowAccountCreted(true);
      // setTimeout(() => {
      //   // navigate("/home");
      // }, 3000);
    } else if (res.meta?.requestStatus === "rejected") {
      if (res.payload?.errors?.email) {
        setError("email", {
          type: "manual",
          message: res.payload?.errors?.email,
        });
      }
      if (res.payload?.errors?.contact_no) {
        setError("contact_no", {
          type: "manual",
          message: res.payload?.errors?.contact_no,
        });
      }
    }
  };

  const handleChangeEmail = () => {
    setOtpSent(false);
    setOtpVerified(false);
    setOtp("");
    setOtpCountdown(0);
    clearErrors("email");
  };

  const sendOtp = async () => {
    const isValid = await trigger("email");

    if (!isValid) return;

    const email = getValues("email");

    setOtpLoading(true);

    try {
      const res = await dispatch(sendSignupOtp({ email }));
      console.log({ resresres: res });

      if (res.meta?.requestStatus === "fulfilled") {
        setOtpSent(true);
        setOtpVerified(false);
        setOtp("");
        setOtpCountdown(OTP_TIMER);

        // setSuccessText(
        //   res?.payload?.data || "OTP sent successfully to your email.",
        // );
        // setShowSucess(true);
      } else {
        setSuccessText(res?.payload?.errors || "Unable to send OTP.");
        setShowError(true);
      }
    } catch (error) {
      setSuccessText(error?.message || "Unable to send OTP.");
      setShowError(true);
    } finally {
      setOtpLoading(false);
    }
  };

  const verifyVendorSignupOtp = async () => {
    if (!otp || otp.length !== 4) {
      setSuccessText("Please enter a valid 4 digit OTP.");
      setShowError(true);
      return;
    }

    const email = getValues("email");

    setOtpLoading(true);

    try {
      const res = await dispatch(verifyOtp({ email, otp }));

      if (res.meta?.requestStatus === "fulfilled") {
        setOtpVerified(true);
        setOtpCountdown(0);
        clearErrors("email");

        setSuccessText(res?.payload?.data || "Email verified successfully.");
        setShowSucess(true);
      } else {
        setOtpVerified(false);
        setSuccessText(res?.payload?.errors || "Invalid OTP.");
        setShowError(true);
      }
    } catch (error) {
      setOtpVerified(false);

      setSuccessText(error?.message || "Invalid OTP.");

      setShowError(true);
    } finally {
      setOtpLoading(false);
    }
  };

  useEffect(() => {
    if (!props?.show) {
      reset();
      setOtp("");
      setOtpSent(false);
      setOtpVerified(false);
      setOtpCountdown(0);
    }
  }, [props?.show]);

  return (
    <div className="signup_div">
      <div className="login_form_div">
        <Form>
          <Form.Group className="gray_input_group input_group">
            <Form.Group className="gray_input_group input_group">
              <Form.Label>Full Name *</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter Full name"
                {...register("name", {
                  required: "Name is required",
                  maxLength: {
                    value: 40,
                    message: "Maximum 40 characters allowed",
                  },
                  pattern: {
                    value: RegxExpression.name,
                    message: "Invalid name ",
                  },
                })}
              />
              {errors?.name && (
                <sup className="text-danger">{errors?.name?.message}</sup>
              )}
            </Form.Group>
            <Form.Group className="gray_input_group input_group">
              <Form.Label>Email *</Form.Label>

              <div className="email_verify_row">
                <div className="email_input_wrap">
                  <Form.Control
                    type="text"
                    placeholder="Enter Email ID"
                    readOnly={otpSent || otpVerified}
                    className={otpVerified ? "email_verified_input" : ""}
                    {...register("email", {
                      required: "Email is required",
                      maxLength: {
                        value: 200,
                        message: "Maximum 200 characters allowed",
                      },
                      pattern: {
                        value: RegxExpression.email,
                        message: "Invalid email",
                      },
                    })}
                  />
                  {otpVerified && (
                    <FontAwesomeIcon
                      icon={faCircleCheck}
                      className="email_verified_icon"
                    />
                  )}
                </div>

                {otpSent || otpVerified ? (
                  <button
                    type="button"
                    className="email_action_btn change_btn"
                    disabled={otpLoading}
                    onClick={handleChangeEmail}
                  >
                    <FontAwesomeIcon icon={faPen} /> Change
                  </button>
                ) : (
                  <button
                    type="button"
                    className="email_action_btn send_btn"
                    onClick={sendOtp}
                    disabled={otpLoading}
                  >
                    {otpLoading ? "Sending..." : "Send OTP"}
                  </button>
                )}
              </div>

              {errors?.email && (
                <sup className="text-danger">{errors.email.message}</sup>
              )}

              {otpVerified && (
                <div className="email_verified_badge">
                  <FontAwesomeIcon icon={faCircleCheck} /> Email verified
                </div>
              )}
            </Form.Group>

            {otpSent && otpCountdown > 0 && !otpVerified && (
              <Form.Group className="gray_input_group input_group">
                <Form.Label>Enter Email OTP *</Form.Label>

                <div className="email_verify_row">
                  <div className="email_input_wrap">
                    <Form.Control
                      type="text"
                      placeholder="Enter 4 digit OTP"
                      value={otp}
                      maxLength={4}
                      onChange={(e) => {
                        const value = e.target.value.replace(/\D/g, "");
                        setOtp(value);
                      }}
                    />
                  </div>

                  <button
                    type="button"
                    className="email_action_btn verify_btn"
                    onClick={verifyVendorSignupOtp}
                    disabled={otpLoading || otp.length !== 4}
                  >
                    {otpLoading ? "Verifying..." : "Verify"}
                  </button>
                </div>

                {/* Timer */}
                <div
                  className={`otp_timer_text ${
                    otpCountdown <= 10 ? "expiring" : ""
                  }`}
                >
                  OTP expires in {formatCountdown(otpCountdown)}
                </div>
              </Form.Group>
            )}
          </Form.Group>

          <Form.Group className="gray_input_group input_group">
            <Form.Label>Mobile Number *</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter mobile number"
              maxLength={10}
              onKeyPress={(e) => {
                if (!/[0-9]/.test(e.key)) {
                  e.preventDefault();
                }
              }}
              {...register("contact_no", {
                required: "Mobile Number is required",
                minLength: {
                  value: 10,
                  message: "Mobile number must be 10 digits",
                },
                maxLength: {
                  value: 10,
                  message: "Mobile number must be 10 digits",
                },
                pattern: {
                  value: /^[0-9]{10}$/,
                  message: "Mobile number must be 10 digits",
                },
              })}
            />
            {errors?.contact_no && (
              <sup className="text-danger">{errors?.contact_no?.message}</sup>
            )}
          </Form.Group>

          <Form.Group className="gray_input_group input_group">
            <Form.Label className="label_text"> Password *</Form.Label>
            <div className="password_holder">
              <Form.Control
                type={showPassword ? "text" : "password"}
                placeholder="Enter Password"
                name="password"
                {...register("password", {
                  required: "Password is required",
                  minLength: {
                    value: 8,
                    message: "Password must be at least 8 characters long",
                  },
                  pattern: {
                    value: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[@$!%*?&]).{8,}$/,
                    message:
                      "Password must be at least 8 characters and contain uppercase, lowercase, number, and special character",
                  },
                })}
                onChange={(e) => setPassword(e.target.value)}
              />
              {errors?.password && (
                <sup className="text-danger">{errors?.password?.message}</sup>
              )}
              <div className="eye-icc">
                <FontAwesomeIcon
                  icon={iconOne}
                  className="icon"
                  onClick={() => togglePasswordVisibility("password")}
                />
              </div>
            </div>
          </Form.Group>

          <Form.Group className="gray_input_group input_group">
            <Form.Label className="label_text"> Confirm Password *</Form.Label>
            <div className="password_holder">
              <Form.Control
                type={showPasswordOne ? "text" : "password"}
                placeholder="Enter Password"
                name="re_password"
                {...register("re_password", {
                  required: "Re-Enter Password  is required",
                })}
                onChange={(e) => setPasswordAgain(e.target.value)}
              />

              <div className="eye-icc">
                <FontAwesomeIcon
                  icon={iconTwo}
                  className="icon"
                  onClick={() => togglePasswordVisibility("reenterPassword")}
                />
              </div>
              {errors?.re_password && (
                <sup className="text-danger">
                  {errors?.re_password?.message}
                </sup>
              )}
            </div>
          </Form.Group>

          {password && (
            <div className="password_check_list">
              <PasswordChecklist
                rules={[
                  "minLength",
                  "specialChar",
                  "number",
                  "capital",
                  "match",
                ]}
                minLength={8}
                value={password}
                valueAgain={passwordAgain}
                onChange={(isValid) => {}}
                style={{
                  fontSize: "10px",
                  padding: "4px",
                  margin: "0",
                }}
              />
            </div>
          )}
        </Form>
      </div>

      <div className="btn_holder">
        <Brown_btn
          btnText="Sign Up"
          onClick={handleSubmit(onSubmit)}
          // type="submit"
          // onClick={() => {
          //     props?.onHide()
          //     props?.setShowAccountCreted()
          //  }}
        />
      </div>

      <p className="dark_text">
        Already have an account?{" "}
        {/* <span
          className="link_text"
          onClick={() => {
            setShowSignUp(false);
          }}
        >
          Log In
        </span> */}
        <button
          type="button"
          className="link_text acc_btn"
          onClick={() => {
            setShowSignUp(false);
          }}
        >
          Log In
        </button>
        .
      </p>

      {/* <div className="or_text_div">
        <p className="or_txt">Or</p>
      </div>

      <div className="google_img_holder">
        <div className="img_holder">
          <img src="/assets/images/modal/google.png" className="g_img" />
        </div>
        <p className="signu_with_g_txt">Sign Up with Google</p>
      </div> */}
      <Login_Modal
        setShowSignUp={setShowSignUp}
        showSignUp={showSignUp}
        setShowAccountCreted={props?.setShowAccountCreted}
        onHide={props?.onHide}
      />

      <Success_Modal
        show={showSucess}
        onHide={() => {
          setShowSucess(false);
        }}
        successText={successText}
      />

      <Delete_Modal
        show={showError}
        onHide={() => {
          setShowError(false);
        }}
        successText={successText}
      />
    </div>
  );
};

export default SignUp_Modal;
